/**
 * Page widths: ONE rule for every build (docs/v2-core/STYLE.md, "Width").
 *
 * Wide pages (dashboard, child profile, community, the stories list,
 * registries, the admin console) span the window, up to 1536px so a line of
 * cards never stretches across an ultra-wide monitor. Forms, settings and
 * articles keep a reading width. This replaced the sim kit's SIM_FULL_WIDTH,
 * which went full width only while a v2 feature was live — so the core
 * product and the demo now share one layout.
 *
 * Literal class strings: Tailwind's JIT cannot see interpolated names.
 */
export const PAGE_WIDTH = {
  /** Dashboards, lists, feeds and the child profile. */
  wide: "max-w-screen-2xl",
  /** Articles and long reading. */
  article: "max-w-4xl",
  /** Settings pages and medium forms. */
  reading: "max-w-3xl",
  /** Short forms and single lists (new child, notifications). */
  narrow: "max-w-2xl",
  /** Tiny forms. */
  compact: "max-w-xl",
} as const;

/**
 * Horizontal page gutter for <main>: 24px on a phone, as on the landing page.
 * Edge-to-edge scrollers (story category pills, shop rows) bleed into it with
 * a matching -mx-6, so don't shrink it.
 */
export const PAGE_GUTTER = "px-6 lg:px-8";

/** The header row's gutter: 16px on a phone so the logo and the icon buttons fit; otherwise the page's. */
export const HEADER_GUTTER = "px-4 sm:px-6 lg:px-8";
